module.exports = __webpack_public_path__ + "assets/img/logo1.4112acae.png";